import { RewardTypeE } from 'primsell-shared-layer/types'

export const RewardNameTypeConfig: Record<RewardTypeE, string> = {
  [RewardTypeE.EVENTS]: 'Events',
  [RewardTypeE.DISCOUNT]: 'Discount',
  [RewardTypeE.FREE_PRODUCT]: 'Free product',
  [RewardTypeE.EXCLUSIVE_ACCESS]: 'Exclusive access',
}
